import { toCamelCaseProperties } from '@/utils/fn';

export default class WebshopSiteFilter {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.id = args.id || 0;
		this.name = args.name || '';
		this.count = args.count || 0;
	}
}
